import {
  Center,
  rem,
  SegmentedControl,
  Tooltip,
  useMantineTheme,
} from '@mantine/core';
import IconBrightness from '@tabler/icons-react/dist/esm/icons/IconBrightness.mjs';
import IconMoonStars from '@tabler/icons-react/dist/esm/icons/IconMoonStars.mjs';
import IconSun from '@tabler/icons-react/dist/esm/icons/IconSun.mjs';
import { useTranslation } from 'react-i18next';
import {
  type ColorSchemeType,
  useColorSchemeStore,
} from '@/shared/lib/hooks/use-app-color-scheme';

export const ThemeSelector = () => {
  const { switchScheme, colorScheme } = useColorSchemeStore(
    ({ colorScheme, switchScheme }) => ({ colorScheme, switchScheme }),
  );
  const { t } = useTranslation();
  const mantineTheme = useMantineTheme();

  const handleTheme = (val: ColorSchemeType) => {
    switchScheme(val);
  };
  return (
    <SegmentedControl
      size='sm'
      // color='dark.4'
      //
      fullWidth
      defaultValue='system'
      classNames={{ label: '!p-0' }}
      data={[
        {
          label: (
            <Tooltip label={t('app.themeSettings.systemTheme')}>
              <Center py={4}>
                <IconBrightness size={16} />
              </Center>
            </Tooltip>
          ),
          value: 'system',
        },
        {
          label: (
            <Tooltip label={t('app.themeSettings.lightTheme')}>
              <Center py={4}>
                <IconSun
                  style={{ width: rem(16), height: rem(16) }}
                  stroke={2.5}
                  color={mantineTheme.colors.yellow[4]}
                />
              </Center>
            </Tooltip>
          ),
          value: 'light',
        },
        {
          label: (
            <Tooltip label={t('app.themeSettings.darkTheme')}>
              <Center py={4}>
                <IconMoonStars
                  style={{ width: rem(16), height: rem(16) }}
                  stroke={2.5}
                  color={`var(--mantine-color-${mantineTheme.primaryColor}-filled)`}
                />
              </Center>
            </Tooltip>
          ),
          value: 'dark',
        },
      ]}
      value={colorScheme}
      onChange={(val: ColorSchemeType) => handleTheme(val)}
    />
  );
};